import request from './request';

const locationInformation = {
	async getLocationDetailsById(options) {
		const response = await request.get('/app/locations/id', options);
		return response;
	},
	async getLocaationIdByRemoteId(options) {
		const response = await request.get('/app/locations/remote-id', options);
		return response;
	}
};

export default locationInformation;